export function getThemes(state: any) {
    return state.theme.list;
}

export function getTheme(state: any) {
    return state.theme.one;
}

export function isLoading(state: any) {
    return state.theme.isLoading;
}
